"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IncentiveType;
(function (IncentiveType) {
    IncentiveType["FINANCIAL"] = "financial";
    IncentiveType["PHYSICAL"] = "physical";
    IncentiveType["CASHBACK"] = "cash_back";
    IncentiveType["INFORMATION"] = "information";
})(IncentiveType || (IncentiveType = {}));
exports.default = IncentiveType;
